import { AppointmentService, IAppointmentService } from "./appointment";
import { AuthService, IAuthService } from "./auth";
import { BroadcastService, IBroadcastService } from "./broadcast";
import { CalendarService, ICalendarService } from "./calendar";
import { ClinicService, IClinicService } from "./clinic";
import { DiagnosisService, IDiagnosisService } from "./diagnosis";
import { GoalService, IGoalService } from "./goal";
import { GoogleService, IGoogleService } from "./google";
import { Health360Service, IHealth360Service } from "./health360";
import { MessageService, IMessageService } from "./message";
import { PatientService, IPatientService } from "./patient";
import { ProviderService, IProviderService } from "./provider";
import { QarePlanService, IQarePlanService } from "./qarePlan";
import { QioskService, IQioskService } from "./qiosk";
import { ServiceService, IServiceService } from "./service";

export interface IProvidedService {
  appointment: IAppointmentService;
  auth: IAuthService;
  broadcast: IBroadcastService;
  calendar: ICalendarService;
  clinic: IClinicService;
  diagnosis: IDiagnosisService;
  goal: IGoalService;
  google: IGoogleService;
  health360: IHealth360Service;
  message: IMessageService;
  patient: IPatientService;
  provider: IProviderService;
  qarePlan: IQarePlanService;
  qiosk: IQioskService;
  service: IServiceService;
}

export const initializeService = (accessToken: string): IProvidedService => ({
  appointment: new AppointmentService(accessToken),
  auth: new AuthService(accessToken),
  broadcast: new BroadcastService(accessToken),
  calendar: new CalendarService(accessToken),
  clinic: new ClinicService(accessToken),
  diagnosis: new DiagnosisService(accessToken),
  goal: new GoalService(accessToken),
  google: new GoogleService(),
  health360: new Health360Service(accessToken),
  message: new MessageService(accessToken),
  patient: new PatientService(accessToken),
  provider: new ProviderService(accessToken),
  qarePlan: new QarePlanService(accessToken),
  qiosk: new QioskService(accessToken),
  service: new ServiceService(accessToken),
});
